import { FC, useContext, useState } from "react";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { AdminCarDriver } from "../../http/carDrivers/types";
import { useOtherCarAssignmentApi } from "../../http/otherCarAssignment/api";
import SvgAdd from "../icons/Add";
import Button from "../ui/Button";
import ModalDialog from "../ui/ModalDialog";
import OtherCarAssignmentForm, { OtherCarAssignmentFormBody } from "./OtherCarAssignmentForm";

const CreateOtherCarAssignmentButton: FC = () => {
  const i18n = useI18n();
  const [show, setShow] = useState(false);
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const otherCarAssignmentApi = useOtherCarAssignmentApi();

  const onSubmit = async (formData: OtherCarAssignmentFormBody, carDriver?: AdminCarDriver) => {
    setIsSubmitting(true);
    try {
      if (carDriver && formData.prevEndDate) {
        await otherCarAssignmentApi.addToOtherCarAssignment({
          carId: formData.car.id,
          startDate: formData.startDate,
          endDate: formData.endDate,
          currentVersionNumber: carDriver.versionNumber,
          prevEndDate: formData.prevEndDate,
          costCenter: formData.costCenter,
          type: formData.type.value,
        });
      } else {
        await otherCarAssignmentApi.insertOtherCarAssignment({
          carId: formData.car.id,
          startDate: formData.startDate,
          endDate: formData.endDate,
          costCenter: formData.costCenter,
          type: formData.type.value,
        });
      }
      dispatch(showSuccessNotification(i18n.t));
      setShow(false);
    } catch (err) {
      dispatch(showErrorNotification(i18n, err));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Button buttonProps={{ onClick: () => setShow(true) }} glyph={SvgAdd} />
      {!!show && (
        <ModalDialog onClose={() => setShow(false)} title={i18n.t.otherCarAssignments.new}>
          <OtherCarAssignmentForm isDisabled={isSubmitting} onSubmit={onSubmit} />
        </ModalDialog>
      )}
    </>
  );
};

export default CreateOtherCarAssignmentButton;
